import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderCardsComponent } from './cards.component';
import { RappiderTitleToolbarModule } from '../title-toolbar/title-toolbar.module';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { RappiderCardOneListModule } from '../card-one-list/card-one-list.module';
import { RappiderInputGroupModule } from '../input-group/input-group.module';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTableModule } from 'ng-zorro-antd/table';
import { FormsModule } from '@angular/forms';
import { RappiderPaginationModule } from '../pagination/pagination.module';
import { RappiderSelectModule } from '../select/select.module';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RappiderCardOneModule } from '../card-one/card-one.module';
import { RappiderMenuModule } from '../menu/menu.module';
import { RappiderButtonModule } from '../button/button.module';
import { RappiderParagraphModule } from '../paragraph/paragraph.module';
import { RappiderDividerModule } from '../divider/divider.module';
import { RappiderTextModule } from '../text/text.module';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { RappiderCheckboxListModule } from '../checkbox-list/checkbox-list.module';
import { RappiderTagModule } from '../tag/tag.module';
import { RappiderHeadingModule } from '../heading/heading.module';
import { RappiderModalModule } from '../modal/modal.module';
import { RappiderLottiePlayerModule } from '../lottie-player/lottie-player.module';
import { RappiderSpinModule } from '../spin/spin.module';

@NgModule({
  declarations: [
    RappiderCardsComponent
  ],
  imports: [
    CommonModule,
    NzCardModule,
    NzTableModule,
    FormsModule,
    RappiderTitleToolbarModule,
    RappiderCardOneListModule,
    RappiderCardOneModule,
    RappiderInputGroupModule,
    NzSkeletonModule,
    RappiderPaginationModule,
    RappiderSelectModule,
    TranslateModule,
    NzIconModule,
    RappiderMenuModule,
    RappiderButtonModule,
    RappiderParagraphModule,
    RappiderDividerModule,
    RappiderTextModule,
    RappiderCheckboxListModule,
    NzCollapseModule,
    RappiderTagModule,
    RappiderHeadingModule,
    RappiderModalModule,
    RappiderLottiePlayerModule,
    RappiderSpinModule
  ],
  exports: [
    RappiderCardsComponent
  ]
})
export class RappiderCardsModule { }
